// ./pdfThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { addPdf } from './pdfSlice';
import { toggleRightSection } from './sectionSlice'; 
import { resetDocGen } from './docGenSlice';
import { RootState } from '../store'; 
import { decrementProcessingCount } from './fileProcessingSlice';

export const handlePdfArrivalThunk = createAsyncThunk(
    'pdf/handlePdfArrival',
    async (filename: string, { dispatch, getState }) => {
        try {
            console.log('handlePdfArrivalThunk: Starting PDF arrival handling for:', filename);
            
            // Get the current active chat group
            const state = getState() as RootState;
            const activeChatGroup = state.chatHistory?.activeChatGroup;
            
            if (!activeChatGroup) {
                console.error('No active chat group for PDF arrival');
                return { success: false, error: 'No active chat group' };
            }
            
            // Add the PDF to the specific chat group
            dispatch(addPdf({ filename, chatGroupId: activeChatGroup }));
            console.log('handlePdfArrivalThunk: PDF added to chat group:', activeChatGroup);

            // Explicitly force the right section open
            dispatch(toggleRightSection(true));
            console.log('handlePdfArrivalThunk: Right section toggled');

            // Reset the docGen state
            dispatch(resetDocGen());
            console.log('handlePdfArrivalThunk: DocGen state reset');

            // Decrement processing count to stop the animation
            dispatch(decrementProcessingCount());
            console.log('handlePdfArrivalThunk: Processing count decremented');

            // Verify the state changes
            const updatedState = getState() as RootState;
            console.log('Current PDF files for chat:', updatedState.pdf.filesByChat[activeChatGroup]);
            console.log('Right section state:', updatedState.section.rightSectionOpen);

            return { success: true, filename, chatGroupId: activeChatGroup };
        } catch (error) {
            console.error('handlePdfArrivalThunk: Error handling PDF arrival:', error);
            throw error;
        }
    }
);